import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["modal"]
  static values = {
    id: String,
    autoShow: Boolean,
    oneTime: Boolean
  }

  connect() {
    this.videoStarted = false
    this.videoTimeout = null
    
    if (this.autoShowValue === undefined) {
      this.autoShowValue = true
    }

    if (this.autoShowValue && this.shouldShow()) {
      this.show()
    }
  }

  show() {
    this.modalTarget.style.display = 'flex'
    
    // Check if this modal has a video before setting up video-related functionality
    const video = this.modalTarget.querySelector('[data-modal-video="true"]')
    if (video) {
      this.videoStarted = false
      
      // Listen for the modal animation to complete before playing video
      const handleAnimationEnd = () => {
        this.startVideoPlayback()
        this.modalTarget.removeEventListener('animationend', handleAnimationEnd)
        if (this.videoTimeout) {
          clearTimeout(this.videoTimeout)
          this.videoTimeout = null
        }
      }
      
      this.modalTarget.addEventListener('animationend', handleAnimationEnd)
      
      // Fallback: if animation doesn't fire, start video after 1.5 seconds
      this.videoTimeout = setTimeout(() => {
        this.startVideoPlayback()
      }, 1500)
    }
  }

  startVideoPlayback() {
    if (this.videoStarted) return
    
    const video = this.modalTarget.querySelector('[data-modal-video="true"]')
    if (video) {
      this.videoStarted = true
      
      // Wait for the video to be ready before playing
      if (video.readyState >= 2) { // HAVE_CURRENT_DATA
        video.play().catch(error => {
          console.log('Video autoplay failed:', error)
        })
      } else {
        // Wait for the video to load before playing
        video.addEventListener('canplay', () => {
          video.play().catch(error => {
            console.log('Video autoplay failed:', error)
          })
        }, { once: true })
      }
    }
  }

  hide() {
    this.modalTarget.style.display = 'none'
    
    // Pause video playback when modal is hidden
    const video = this.modalTarget.querySelector('[data-modal-video="true"]')
    if (video) {
      video.pause()
    }
    
    if (this.oneTimeValue) {
      this.setCookie()
    }
  }

  setCookieAndNavigate(event) {
    if (this.oneTimeValue) {
      this.setCookie()
    }
  }

  shouldShow() {
    return !this.oneTimeValue || !this.hasSeenModal()
  }

  get cookieName() {
    return `${this.idValue}_seen`
  }

  hasSeenModal() {
    return document.cookie.split(';').some(cookie => 
      cookie.trim().startsWith(`${this.cookieName}=`)
    )
  }

  setCookie() {
    document.cookie = `${this.cookieName}=true; max-age=31536000; path=/`
  }
} 